import './style.scss';

class Modal {
    constructor(params) {
        this.settings = {
            ...this.defaults(),
            ...params,
        }
    }

    defaults() {
        return {
            baseSelector: 'body',
            el: null,
            overlayClose: true,
            closeAfterFunc: null,
            modifierClass: null,
        }
    }

    setDom(dom) {
        this.settings.el = dom
        return this
    }

    show() {
        this.createDom = this.createHtml()

        this.removeElement(document.querySelector('.plugin-modal'))
        document.querySelector(this.settings.baseSelector).appendChild(this.createDom)

        setTimeout(() => {
            this.createDom.dataset.active = '';
            const content = this.createDom.querySelector('.plugin-modal__content');
            content.scrollLeft = (content.scrollWidth - content.clientWidth) / 2;
        }, 100)

        this.createDom.querySelector('.plugin-modal__close').addEventListener('click', () => {
            this.close()
        })
        if (this.settings.overlayClose) {
            this.createDom.querySelector('.plugin-modal__overlay').addEventListener('click', () => {
                this.close()
            })
        }
    }

    removeElement(element) {
        if (!element) return
        element.parentNode.removeChild(element)
    }

    close(removeFlg = true) {
        delete this.createDom.dataset.active;
        if (removeFlg) {
            this.settings.el.parentNode.removeChild(this.settings.el)
        }
        if (this.settings.closeAfterFunc) {
            this.settings.closeAfterFunc()
        }
    }

    createHtml() {
        let div = document.createElement('div')
        div.classList.add('plugin-modal');
        if (this.settings.modifierClass) {
            div.classList.add(this.settings.modifierClass);
        }
        let baseHtml = `<div class="plugin-modal__overlay"></div><div class="plugin-modal__content-wrap"><div class="plugin-modal__content"></div><div class="plugin-modal__close">${this.closeIcon()}</div></div>`
        div.innerHTML = baseHtml

        div.querySelector('.plugin-modal__content').appendChild(this.settings.el)
        return div
    }

    closeIcon() {
        return `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24"><polygon points="14 12 19.4 6.6 17.4 4.6 12 10 10.3 8.3 6.6 4.6 4.6 6.6 8.3 10.3 10 12 4.6 17.4 6.6 19.4 12 14 13.7 15.7 17.4 19.4 19.4 17.4 15.7 13.7 14 12"/></svg>`
    }
}

export default Modal;
